/**
 * Component managing infinite scroll or manual "load more" functionality for product collections.
 * @extends HTMLElement
 */
class infinityButton extends HTMLElement {
  constructor() {
    super();
    this.link = this.querySelector('.btn');
    this.link&&this.link.addEventListener('click', this.handler.bind(this));
    this.classList.contains('autoscroll_yes') && window.addEventListener('scroll', this.autoscrollhandler.bind(this));
  }

  /**
   * Fetches and appends next page content via AJAX.
   * @param {Event} event
   */
  handler(event){
    event.preventDefault();
    if(this.destroyed || this.loading || !this.link || this.link.getAttribute('aria-disabled') === 'true' || this.link.hasAttribute('disabled')) return false;
    var url = this.link.getAttribute('href');
    if(!url || !url.trim()) return false;
    this.loading = true;
    placeCollectionLoader();
    document.querySelector('.collection_facets_loader').classList.add('loading_now');
    fetch(url)
      .then((response) => {
        if(!response.ok) throw new Error('Unable to load collection page');
        return response.text();
      })
      .then((responseText) => {
        const html = responseText;
        var container = false,
            _html = false;
        
        container = document.querySelector('.collection__container').lastElementChild;
        _html = new DOMParser().parseFromString(html, 'text/html').querySelector('.collection__container').innerHTML;
        container.insertAdjacentHTML("afterend", _html);

        container = document.querySelector('infinity-button');
        _html = new DOMParser().parseFromString(html, 'text/html').querySelector('infinity-button');
        container.replaceWith(_html);

    })
      .catch((error) => console.error('Collection pagination:', error))
      .finally(() => {
        this.loading = false;
        document.querySelector('.collection_facets_loader')?.classList.remove('loading_now');
      });
  }

  /** Triggers click event when button scrolls into view if autoscroll is enabled. */
  autoscrollhandler(){
    if(!this.link || this.destroyed) return false;
    if(!this.link.classList.contains('autoscroll')) return false;
    var contY = parseInt(this.link.parentNode.offsetTop);
    var wY = this.getWindowHeight()+this.getWindowTopY();
    if( contY <= wY ) {
      this.link.classList.remove('autoscroll');
      this.link.dispatchEvent(new Event('click', {bubbles: true, cancelable: true}));
    }
  }

  getWindowHeight(){
    return window.innerHeight;
  }

  getWindowTopY(){
    return window.pageYOffset || document.documentElement.scrollTop;
  }

  disconnectedCallback(){
    this.destroyed = true;
    this.remove();
  }
}
customElements.define('infinity-button', infinityButton);